export default __webpack_public_path__ + "static/media/Quica.7a73ccce.jpg";